import useSearchCategoryChange from 'hooks/useSearchCategoryChange';
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  updateNodeFuctionalText,
  updateNodeFunctionalLevel,
  resetFilterSideBar,
  saveCurrentDepartment,
} from "redux/actions";

const Item = (props) => {
  const {
    node,
    onClick,
    isChildNodesOpenDefault,
    category_ids,
    slug,
    text,
    product_count,
    isRootItem,
    funtional_level,
    function_names,
    redirectBaseUrl,
    querySearchKey,
    length,
    search_type,
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { searchType } = useSelector(({ search }) => search);
  const currentSelection = [slug, search_type].includes(searchType)
  

  const handleChangeSelectedOption = useSearchCategoryChange();

  let setSearchParams = useSearchParams()[1];

  const { nodeFunctionalText, nodeFunctionalLevel } = useSelector(
    ({ product }) => product
  );

  const handleNodeChange = (
    search_type,
    isRootItem,
    text,
    funtional_level,
    function_names,
    category_ids
  ) => {
    if (["products", "coupons"].includes(search_type)) {
      handleChangeSelectedOption(search_type);
      return
    }

    if (isRootItem) {
      navigate(`/${redirectBaseUrl}/${slug}`);
      dispatch(resetFilterSideBar());
      return
    }

    dispatch(updateNodeFuctionalText(text));
    dispatch(updateNodeFunctionalLevel(funtional_level));
    if (querySearchKey === "category_ids") {
      setSearchParams({ category_ids: category_ids });
    } else {
      setSearchParams({ function_names: function_names });
    }
  };

  return (
    <div>
      <div
        className={
          currentSelection ||
          isChildNodesOpenDefault ||
          (nodeFunctionalText === text &&
            nodeFunctionalLevel === funtional_level)
            ? "department-item active"
            : "department-item"
        }
        key={category_ids}
      >
        <div
          className="title-alignment"
          onClick={() => {
            handleNodeChange(
              search_type,
              isRootItem,
              text,
              funtional_level,
              function_names,
              category_ids
            );
          }}
        >
          <div>
            {text}
          </div>
        </div>
        {length == 1 && (
          <div
            onClick={() => {
              dispatch(saveCurrentDepartment(""));
            }}
          >
            Clear
          </div>
        )}
      </div>
    </div>
  );
};

const DepartmentListItemTheme2 = React.memo(
  ({ departmentTree, redirectBaseUrl, querySearchKey }) => {
    const [departmentTreeList, setDepartmentTree] = useState(departmentTree);
    const { departmentSlug } = useParams();

    useEffect(() => {
      setDepartmentTree(departmentTree);
    }, [departmentTree]);

    return (
      <div>
        {departmentTreeList
          ? departmentTreeList.map((item, index) => (
              <Item
                key={index}
                isRootItem={true}
                isChildNodesOpenDefault={departmentSlug === item.slug}
                {...item}
                redirectBaseUrl={redirectBaseUrl}
                querySearchKey={querySearchKey}
                length={departmentTreeList.length}
              />
            ))
          : ""}
      </div>
    );
  }
);

export default DepartmentListItemTheme2;
